import { module } from 'angular';
import kidComponent from './input-kid.component';
import './input-kid.scss';

export default module('app')
	.component('inputKid', kidComponent)
	.name;
